import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32b81b82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 1,
  class: "pb-5 mb-5"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-4 pt-3" }, null, -1))
const _hoisted_5 = {
  key: 2,
  class: "order-fetch-failed"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, "お仕事の取得に失敗しました", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_BButton = _resolveComponent("BButton")!
  const _component_BButtonGroup = _resolveComponent("BButtonGroup")!
  const _component_Header = _resolveComponent("Header")!
  const _component_OrderCard = _resolveComponent("OrderCard")!
  const _component_SameOfficeOrders = _resolveComponent("SameOfficeOrders")!
  const _component_OrderIntroContents = _resolveComponent("OrderIntroContents")!
  const _component_OrderTabContents = _resolveComponent("OrderTabContents")!
  const _component_OrderFixedButton = _resolveComponent("OrderFixedButton")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_OfficeMuteModal = _resolveComponent("OfficeMuteModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.orderDetail)
      ? (_openBlock(), _createBlock(_component_Header, { key: 0 }, {
          left: _withCtx(() => [
            _createVNode(_component_FeatherIcon, {
              icon: "chevron-left",
              onClick: _ctx.goBack
            }, null, 8, ["onClick"])
          ]),
          right: _withCtx(() => [
            (_ctx.transitionSource === 'Search')
              ? (_openBlock(), _createBlock(_component_BButtonGroup, {
                  key: 0,
                  class: "paginate",
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BButton, {
                      variant: "bg-gray-06",
                      onClick: _ctx.prevOrder,
                      class: _normalizeClass(["button", { disabled: !_ctx.hasPrevOrder }]),
                      disabled: !_ctx.hasPrevOrder
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_FeatherIcon, { icon: "arrow-up" })
                      ], undefined, true),
                      _: 1
                    }, 8, ["onClick", "class", "disabled"]),
                    _createTextVNode(),
                    _createVNode(_component_BButton, {
                      variant: "bg-gray-06",
                      onClick: _ctx.nextOrder,
                      class: _normalizeClass(["button", { disabled: !_ctx.hasNextOrder }]),
                      disabled: !_ctx.hasNextOrder
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_FeatherIcon, { icon: "arrow-down" })
                      ], undefined, true),
                      _: 1
                    }, 8, ["onClick", "class", "disabled"])
                  ], undefined, true),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createTextVNode(),
            _createTextVNode(),
            (_ctx.isInitializeComplete)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.orderDateTime), 1))
              : _createCommentVNode("", true),
            _createTextVNode(),
            (_ctx.isOrderFetchingFailed)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "エラー"))
              : _createCommentVNode("", true)
          ], undefined, true),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (_ctx.isInitializeComplete && _ctx.orderDetail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(),
          _createVNode(_component_OrderCard, {
            ref: "orderCard",
            order: _ctx.orderDetail,
            selectedWorkTimeOptionId: _ctx.selectedWorkTimeOptionId,
            "onUpdate:selectedWorkTimeOptionId": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedWorkTimeOptionId) = $event)),
            evaluationTotalAverage: _ctx.evaluationTotalAverage,
            evaluationCount: _ctx.evaluationCount,
            orderService: _ctx.orderService,
            displayCarfare: "",
            isLogin: _ctx.isLogin,
            isCarousel: "",
            isFavorite: _ctx.isFavorite,
            isMutedOffice: _ctx.isMutedOffice,
            application: _ctx.application,
            isRegisteredWatchLater: _ctx.isRegisteredWatchLater,
            onFavoriteChange: _ctx.onClickFavoriteOffice,
            onChangeMutedOffice: _ctx.onClickMuteButton,
            onChangeWatchLater: _ctx.onWatchLaterChange,
            showOfficeFavoriteButton: _ctx.showOfficeFavoriteButton
          }, null, 8, ["order", "selectedWorkTimeOptionId", "evaluationTotalAverage", "evaluationCount", "orderService", "isLogin", "isFavorite", "isMutedOffice", "application", "isRegisteredWatchLater", "onFavoriteChange", "onChangeMutedOffice", "onChangeWatchLater", "showOfficeFavoriteButton"]),
          _createTextVNode(),
          _createVNode(_component_SameOfficeOrders, {
            "order-detail": _ctx.orderDetail,
            "applicable-orders": _ctx.applicableOrders,
            class: "mt-2"
          }, null, 8, ["order-detail", "applicable-orders"]),
          _createTextVNode(),
          _createVNode(_component_OrderIntroContents, {
            orderDetail: _ctx.orderDetail,
            class: "mt-2"
          }, null, 8, ["orderDetail"]),
          _createTextVNode(),
          _createVNode(_component_OrderTabContents, {
            order: _ctx.orderDetail,
            favoriteOffice: _ctx.favoriteOffice,
            isLogin: _ctx.isLogin,
            anonymousEvaluations: _ctx.anonymousEvaluations,
            evaluationCount: _ctx.evaluationCount,
            evaluationTotalAverage: _ctx.evaluationTotalAverage,
            class: "mt-2",
            onClickNoticeOfEmployment: _ctx.onClickNoticeOfEmployment,
            onClickAttachmentFile: _ctx.onClickAttachmentFile,
            onClickViewRoot: _ctx.onClickViewRoot
          }, null, 8, ["order", "favoriteOffice", "isLogin", "anonymousEvaluations", "evaluationCount", "evaluationTotalAverage", "onClickNoticeOfEmployment", "onClickAttachmentFile", "onClickViewRoot"]),
          _createTextVNode(),
          (!_ctx.isLogin || _ctx.canApply || _ctx.isFetchingCanApply)
            ? (_openBlock(), _createBlock(_component_OrderFixedButton, {
                key: 0,
                onClick: _ctx.onClickApply,
                isShownWatchLaterButton: _ctx.isShownWatchLaterButton,
                isRegisteredWatchLater: _ctx.isRegisteredWatchLater,
                isDisabled: _ctx.isFetchingCanApply,
                abTestGroup3300: _ctx.abTestGroup3300,
                enabledVariant: "primary",
                onChangeWatchLater: _ctx.onWatchLaterChange
              }, {
                default: _withCtx(() => [
                  (_ctx.isFetchingCanApply)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("応募可否確認中")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("申し込みへ進む")
                      ], 64))
                ], undefined, true),
                _: 1
              }, 8, ["onClick", "isShownWatchLaterButton", "isRegisteredWatchLater", "isDisabled", "abTestGroup3300", "onChangeWatchLater"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (!_ctx.hasRegisteredProfile)
                  ? (_openBlock(), _createBlock(_component_OrderFixedButton, {
                      key: 0,
                      onClick: _ctx.onClickRegistration,
                      isShownWatchLaterButton: _ctx.isShownWatchLaterButton,
                      isRegisteredWatchLater: _ctx.isRegisteredWatchLater,
                      abTestGroup3300: _ctx.abTestGroup3300,
                      enabledVariant: "primary",
                      onChangeWatchLater: _ctx.onWatchLaterChange
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("\n          応募する\n        ")
                      ], undefined, true),
                      _: 1
                    }, 8, ["onClick", "isShownWatchLaterButton", "isRegisteredWatchLater", "abTestGroup3300", "onChangeWatchLater"]))
                  : (!_ctx.hasQualification)
                    ? (_openBlock(), _createBlock(_component_RouterLink, {
                        key: 1,
                        to: { name: 'MypageQualificationList' }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_OrderFixedButton, {
                            isShownWatchLaterButton: _ctx.isShownWatchLaterButton,
                            isRegisteredWatchLater: _ctx.isRegisteredWatchLater,
                            abTestGroup3300: _ctx.abTestGroup3300,
                            enabledVariant: "primary",
                            onChangeWatchLater: _ctx.onWatchLaterChange,
                            hasSub: "",
                            onClick: _ctx.onClickApplyingButton
                          }, {
                            sub: _withCtx(() => [
                              _createTextVNode("応募には資格情報の入力が必要です")
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode("\n            資格登録にすすむ\n            ")
                            ], undefined, true),
                            _: 1
                          }, 8, ["isShownWatchLaterButton", "isRegisteredWatchLater", "abTestGroup3300", "onChangeWatchLater", "onClick"])
                        ], undefined, true),
                        _: 1
                      }))
                    : (!_ctx.hasBankAccount)
                      ? (_openBlock(), _createBlock(_component_RouterLink, {
                          key: 2,
                          to: { name: 'SetBank' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_OrderFixedButton, {
                              isShownWatchLaterButton: _ctx.isShownWatchLaterButton,
                              isRegisteredWatchLater: _ctx.isRegisteredWatchLater,
                              abTestGroup3300: _ctx.abTestGroup3300,
                              enabledVariant: "primary",
                              onChangeWatchLater: _ctx.onWatchLaterChange,
                              hasSub: "",
                              onClick: _ctx.onClickApplyingButton
                            }, {
                              sub: _withCtx(() => [
                                _createTextVNode("応募には口座情報の入力が必要です")
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode("\n            口座登録にすすむ\n            ")
                              ], undefined, true),
                              _: 1
                            }, 8, ["isShownWatchLaterButton", "isRegisteredWatchLater", "abTestGroup3300", "onChangeWatchLater", "onClick"])
                          ], undefined, true),
                          _: 1
                        }))
                      : (!_ctx.hasRegisteredBusinessInfo)
                        ? (_openBlock(), _createBlock(_component_RouterLink, {
                            key: 3,
                            to: { name: 'MypageBusinessInfo' }
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_OrderFixedButton, {
                                isShownWatchLaterButton: _ctx.isShownWatchLaterButton,
                                isRegisteredWatchLater: _ctx.isRegisteredWatchLater,
                                abTestGroup3300: _ctx.abTestGroup3300,
                                enabledVariant: "primary",
                                onChangeWatchLater: _ctx.onWatchLaterChange,
                                hasSub: "",
                                onClick: _ctx.onClickApplyingButton
                              }, {
                                sub: _withCtx(() => [
                                  _createTextVNode("\n              応募には経験・転職意欲の入力が必要です\n            ")
                                ]),
                                default: _withCtx(() => [
                                  _createTextVNode("\n            経験・転職意欲登録にすすむ\n            ")
                                ], undefined, true),
                                _: 1
                              }, 8, ["isShownWatchLaterButton", "isRegisteredWatchLater", "abTestGroup3300", "onChangeWatchLater", "onClick"])
                            ], undefined, true),
                            _: 1
                          }))
                        : (_ctx.application)
                          ? (_openBlock(), _createBlock(_component_OrderFixedButton, {
                              key: 4,
                              isShownWatchLaterButton: _ctx.isShownWatchLaterButton,
                              isRegisteredWatchLater: _ctx.isRegisteredWatchLater,
                              onChangeWatchLater: _ctx.onWatchLaterChange,
                              isDisabled: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("\n          応募済みです\n        ")
                              ], undefined, true),
                              _: 1
                            }, 8, ["isShownWatchLaterButton", "isRegisteredWatchLater", "onChangeWatchLater"]))
                          : (_openBlock(), _createBlock(_component_OrderFixedButton, {
                              key: 5,
                              isShownWatchLaterButton: _ctx.isShownWatchLaterButton,
                              isRegisteredWatchLater: _ctx.isRegisteredWatchLater,
                              onChangeWatchLater: _ctx.onWatchLaterChange,
                              hasSub: "",
                              isDisabled: ""
                            }, {
                              sub: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.canNotApplyReason), 1)
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode("\n          応募できません\n          ")
                              ], undefined, true),
                              _: 1
                            }, 8, ["isShownWatchLaterButton", "isRegisteredWatchLater", "onChangeWatchLater"]))
              ], 64))
        ]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (_ctx.isOrderFetchingFailed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createTextVNode(),
          _createVNode(_component_AppButton, { onClick: _ctx.goSearch }, {
            default: _withCtx(() => [
              _createTextVNode("お仕事検索に戻る")
            ], undefined, true),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (_ctx.orderDetail)
      ? (_openBlock(), _createBlock(_component_OfficeMuteModal, {
          key: 3,
          isShown: _ctx.isShownMutedOfficeModal,
          officeName: _ctx.orderDetail.office.name,
          onSubmit: _ctx.onSubmitMuteOfficeModal,
          onCancel: _ctx.onCloseMuteOfficeModal
        }, null, 8, ["isShown", "officeName", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true)
  ]))
}